import { render, staticRenderFns } from "./FeedbackBulkUpdater.vue?vue&type=template&id=d46fd6fa&scoped=true"
import script from "./FeedbackBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./FeedbackBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackBulkUpdater.vue?vue&type=style&index=0&id=d46fd6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46fd6fa",
  null
  
)

export default component.exports